<template>
	<fragment>
		<!-- Filters -->
		<filter-sidebar v-bind:filters="filters" v-bind:secondaryfilters="secondaryFilters"></filter-sidebar>

		<div class="global-container">
			<section class="section bg-white">
				<div class="row">
					<div class="col-lg-12" v-if="listing.length > 0">
						<ul class="testimonial-info">
							<template v-if="storytype == 'healthpro'">
								<shared-story-prof-item v-for="(item, index) in listing"
												   v-bind:item="item"
												   v-bind:key="item.DetailID">
								</shared-story-prof-item>
							</template>
							<template v-else>
								<shared-story-item v-for="(item, index) in listing"
												   v-bind:item="item"
												   v-bind:key="item.DetailID">

								</shared-story-item>
							</template>
						</ul>
						<section class="section bg-white" v-if="listing.length > 0 && pagination.totalPages > 1">
							<div class="row">
								<div class="col-12">
									<pagination></pagination>
								</div>
							</div>
						</section>
					</div>
					<div class="col-lg-12 align-center" v-if="listing.length === 0">
						<h2 class="not-found-heading">Sorry, no stories were found matching your specifications.</h2>
						<p>
							Try removing some filters or searching a different term.
						</p>
					</div>
				</div>
			</section>
		</div>

	</fragment>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import Pagination from '../components/listing/pagination-dropdown';
    import SharedStoryItem from '../components/listing/story-item';
    import SharedStoryProfItem from '../components/listing/story-prof-item';
	import FilterSidebar from '../components/listing/filter-sidebar';
    import diseaseFilter from '../filters/story-disease-filter';
	import topicFilter from '../filters/story-topic-filter';
	import stateSearchFilter from '../filters/story-statesearch-filter';
	import stateFilter from '../filters/story-state-filter';
    import searchFilter from '../filters/story-search-filter';
	import sharedStoryFilter from '../filters/shared-story-filter';
	import dateFilter from '../filters/story-filter-dates';
	import * as CONST from '../utils/constants';

	export default {
		props: ['filterid', 'filtertype', 'storytype', 'result', 'resource'],
		data: function () {
			return {
				displayDate: CONST.globalProject.DisplayListingDates || false,
				filters: {},
				secondaryFilters: null,
			}
		},
		computed: mapState({
			loading: state => state.listing.loading,
			listing: state => state.listing.listing,
			pagination: state => state.listing.pagination,
		}),
		components: {
			pagination: Pagination,
            'shared-story-item': SharedStoryItem,
            'shared-story-prof-item': SharedStoryProfItem,
			'filter-sidebar': FilterSidebar,
		},
		mounted: function () {
			let _this = this;

			// take props and send to vuex store
			this.setInitData(this.result);
			this.setResource(this.resource);

			// import correct filters for this view based on prop value
			if (this.filtertype == "disease") {
				this.filters = diseaseFilter;
			} else if (this.filtertype == "topic") {
				this.filters = topicFilter;
            } else if (this.filtertype == "state-search") {
                this.filters = stateSearchFilter;
            } else if (this.filtertype == "state") {
                this.filters = stateFilter;
            } else if (this.filtertype == "search") {
                this.filters = searchFilter;
            } else if (this.filtertype == "none") {
				$('.filter-bar').hide();
            } else if (this.filtertype == "all") {
                this.filters = sharedStoryFilter;
            };

			//this.filters = dateFilter;
			if (Object.keys(dateFilter).length) {
				this.secondaryFilters = dateFilter;
			}

			// import correct filters for this view based on prop value
			//if (this.filtertype === 'sharedStoryFilter') {
				//this.filters = sharedStoryFilter;
			//};

			this.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setFilter') {
					$('html, body').animate({
						scrollTop: $('.filter-app').offset().top
					}, 1000);
				}
			})

			// if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
					this.setFilter();
				}
			});
		},
		methods: {
			...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', { setInitData: 'setInitData' }),
			...mapMutations('listing', { setResource: 'setResource' }),
        },
    }
</script>